import Typography from '@mui/material/Typography';


export default function InfoSeqText() {
  
  return (
<div>
    
<Typography variant="subtitle1">
    
<Typography component="span" variant="subtitle1" sx={{fontWeight: 600}}>Sequencing & Genotyping</Typography>
<br /><br />

 To generate your pharmacogenetic results, we analyzed specific genes known to play a role in how your body processes medications. These genes influence
the activity of enzymes involved in drug absorption, breakdown, and clearance.

<br /><br />
<Typography component="span" variant="subtitle1" sx={{fontWeight: 600}}>What Was Analyzed?</Typography>
<br /><br />

Your DNA was examined for genetic variants (called polymorphisms) in key pharmacogenes - genes that are responsible for drug metabolism, transport, and response. 
These include key drug-metabolizing enzymes like CYP2D6, CYP2C19, TPMT, DPYD, and others. Each of these genes can affect how quickly or
slowly your body responds to certain medications, or whether a drug may be more likely to cause side effects.<br /><br />

<Typography component="span" variant="subtitle1" sx={{fontWeight: 600}}>How Were the Results Interpreted?</Typography>
<br /><br />

Once your genetic data was obtained, it was compared against clinical pharmacogenetic databases and international guidelines, 
including such as CPIC (Clinical Pharmacogenetics Implementation Consortium), DPWG (Dutch Pharmacogenetics Working Group) and PharmGKB (Pharmacogenomics
Knowledgebase). Each drug-gene interaction in your report reflects expert-curated recommendations, which are regularly updated as new scientific
findings become available. 
<br /><br />

We use established algorithms to match your genetic variants to known phenotypes 
(e.g. poor, intermediate, normal, ultrarapid metabolizer) and derive the appropriate drug recommendations from current medical guidelines.

<br /><br />

<Typography component="span" variant="subtitle1" sx={{fontWeight: 600}}>Limitations</Typography>
<br /><br />

Not all medications are covered by current pharmacogenetic knowledge, and not every gene-drug interaction is fully understood yet. 
In some cases, your result may be marked as “not available” or “uncertain significance.” 
As the science advances, more results may become actionable.
Your results should always be discussed with a healthcare provider or pharmacogenetic counselor before making any medication changes.
<br /><br />

</Typography>    
</div>

   )
}